var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F7D4D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98826 12.9517C7.29108 12.6691 7.76567 12.6854 8.04829 12.9883C9.04498 14.0528 10.0899 15.1179 11.25 16.0072V6.75007C11.25 6.33586 11.5858 6 12 6C12.4142 6 12.75 6.33642 12.75 6.75064V16.0072C13.9106 15.1175 14.9529 14.0551 15.9517 12.9883C16.2343 12.6854 16.7089 12.6691 17.0117 12.9517C17.3146 13.2343 17.3308 13.709 17.0482 14.0119C15.9656 15.1712 14.8471 16.31 13.575 17.2641C13.129 17.5986 12.5834 18 12 18C11.4166 18 10.871 17.5986 10.425 17.2641C9.1606 16.3158 8.03082 15.1609 6.95171 14.0117C6.66909 13.7089 6.68545 13.2343 6.98826 12.9517Z",
    fill: "#660008"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusArrowDown);
export default __webpack_public_path__ + "static/media/statusArrowDown.fb91adf76ff7b288a4b85a092aeb0ba3.svg";
export { ForwardRef as ReactComponent };